import { styled } from '@mui/material/styles';
import { ListItem } from '@mui/material';

// rowStyles ----------------------------------------------------------------

export const ManageRow = styled(ListItem, {
  shouldForwardProp: (p) => !['listRow', 'rowBg', 'headerRow'].includes(p),
})(({ theme, listRow, rowBg, headerRow }) => ({
  fontSize: 13,
  ...(listRow ? { cursor: 'pointer' } : {}),
  ...(rowBg ? { backgroundColor: theme.palette.action.disabledBackground } : {}),
  ...(headerRow ? { borderBottom: `1px solid ${theme.palette.divider}` } : {}),
}));

export const ManageFlexRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
});

export const ManageName = styled('div')(({ theme }) => ({
  width: '36%',
  display: 'flex',
  paddingRight: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const ManageItem33 = styled('div', {
  shouldForwardProp: (p) => p !== 'item50',
})(({ item50 }) => ({
  width: item50 ? '50%' : '33%',
}));

export const ManageItem50 = styled('div')({
  width: '50%',
});

export const ManageAccess = styled('div')(({ theme }) => ({
  width: '36%',
  display: 'flex',
  paddingRight: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const ManageStatus = styled('div')(({ theme }) => ({
  width: '18%',
  display: 'flex',
  paddingRight: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const ManageCheckbox = styled('div')({
  width: '36px',
});

export const ManageAccessIcon = styled('span')({
  marginRight: 5,
  display: 'inline-flex',
  alignItems: 'center',
});

export const ManageItemSm = styled('div')(({ theme }) => ({
  width: '40%',
  marginRight: theme.spacing(1),
  overflow: 'hidden',
  paddingBottom: theme.spacing(0.5),
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const ManageItemMd = styled('div', {
  shouldForwardProp: (p) => p !== 'xsHide',
})(({ theme, xsHide }) => ({
  width: '50%',
  marginRight: theme.spacing(1),
  overflow: 'hidden',
  paddingBottom: theme.spacing(0.5),
  [theme.breakpoints.down('md')]: {
    width: '100%',
    ...(xsHide ? { display: 'none' } : {}),
  },
}));

export const ManageItemLg = styled('div', {
  shouldForwardProp: (p) => p !== 'xsHide',
})(({ theme, xsHide }) => ({
  width: '60%',
  marginRight: theme.spacing(1),
  overflow: 'hidden',
  paddingBottom: theme.spacing(0.5),
  [theme.breakpoints.down('md')]: {
    width: '100%',
    ...(xsHide ? { display: 'none' } : {}),
  },
}));

export const ManageXsHide = styled('span')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

// default useStyles --------------------------------------------------------

export const ManageSelectedContainer = styled('div')({});

export const ManageSelectedText = styled('div')(({ theme }) => ({
  fontSize: 13,
  fontWeight: 'bold',
  fontStyle: 'italic',
  padding: theme.spacing(2),
}));

export const ManageButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: theme.spacing(1),

  '& button': {
    backgroundColor: theme.palette.secondary.main,
    marginRight: theme.spacing(1),
    color: theme.palette.common.white,

    '&:first-child': {
      backgroundColor: theme.palette.common.black,
    },

    '&.accessButton': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));

export const ManageFormContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '0 auto',

  '& .MuiInputBase-root': {
    width: '100%',
  },
  '& .MuiFormGroup-root': {
    backgroundColor: theme.palette.action.disabled,
    width: '85%',
    marginTop: theme.spacing(3),
    padding: `0 ${theme.spacing(1)}`,
  },
}));

export const ManageModalContent = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
}));

export const ManageModalTitle = styled('div')(({ theme }) => ({
  fontWeight: 'bold',
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

export const ManageNameRow = styled('div')(({ theme }) => ({
  margin: theme.spacing(2),
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

export const ManageCenterLoader = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  flexGrow: 1,
  alignItems: 'center',
  justifyContent: 'center',
});

export const ManageBarTitle = styled('div')({
  textAlign: 'center',
  width: '100%',
});

export const ManageTitle = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ManageProfileContainer = styled('div')({
  position: 'relative',
  top: 64,
});

export const ManageDefaultXsHide = styled('span')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));
